import { render, staticRenderFns } from "./MoedaItem.vue?vue&type=template&id=80386078"
import script from "./MoedaItem.vue?vue&type=script&lang=js"
export * from "./MoedaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports